module.exports = __webpack_public_path__ + "img/power3.235586df.png";